var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      attrs: { "data-vv-scope": "file-form", autocomplete: "off" },
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.save($event)
        }
      }
    },
    [
      _c(
        "div",
        [
          _c(
            "b-alert",
            {
              staticClass: "mt-2 mb-3 p-3",
              attrs: { variant: "danger", dismissible: "" },
              model: {
                value: _vm.showErrorMessage,
                callback: function($$v) {
                  _vm.showErrorMessage = $$v
                },
                expression: "showErrorMessage"
              }
            },
            [
              _c("span", { staticClass: "text-xs primary-text" }, [
                _vm._v(
                  " Existen errores que debes corregir antes de continuar! "
                )
              ])
            ]
          ),
          _c(
            "div",
            [
              _c(
                "b-form-group",
                {
                  attrs: { label: "Nombre para documento", "label-for": "name" }
                },
                [
                  _c("b-form-input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|max:255",
                        expression: "'required|max:255'"
                      }
                    ],
                    staticClass: "w-100",
                    attrs: {
                      id: "name",
                      name: "name",
                      "data-cy": "document-name",
                      autocomplete: "off",
                      "data-vv-as": "Nombre para documento",
                      state:
                        !_vm.errors.has("file-form.name") &&
                        _vm.formValues.name.length > 0
                    },
                    model: {
                      value: _vm.formValues.name,
                      callback: function($$v) {
                        _vm.$set(_vm.formValues, "name", $$v)
                      },
                      expression: "formValues.name"
                    }
                  }),
                  _c("FormError", {
                    attrs: {
                      attributeName: "file-form.name",
                      errorsForm: _vm.errors
                    }
                  })
                ],
                1
              ),
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: "¿Es un documento de acceso público?",
                    "label-for": "isPublic"
                  }
                },
                [
                  _c(
                    "vs-switch",
                    {
                      staticClass: "w-16",
                      attrs: {
                        id: "isPublic",
                        name: "isPublic",
                        "data-cy": "public-document",
                        color: "primary",
                        "vs-icon-on": "done",
                        "vs-icon-off": "block"
                      },
                      model: {
                        value: _vm.formValues.isPublic,
                        callback: function($$v) {
                          _vm.$set(_vm.formValues, "isPublic", $$v)
                        },
                        expression: "formValues.isPublic"
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "pl-1",
                          attrs: { slot: "on" },
                          slot: "on"
                        },
                        [_vm._v("SI")]
                      ),
                      _c("span", { attrs: { slot: "off" }, slot: "off" }, [
                        _vm._v("NO")
                      ])
                    ]
                  )
                ],
                1
              ),
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: "Estado de publicación:",
                    "label-for": "publicationState"
                  }
                },
                [
                  _c("b-form-select", {
                    staticClass: "w-100",
                    attrs: {
                      label: "",
                      id: "publicationState",
                      name: "publicationState",
                      "data-cy": "publication-status",
                      options: _vm.publicationStateOptions
                    },
                    model: {
                      value: _vm.formValues.publicationState,
                      callback: function($$v) {
                        _vm.$set(_vm.formValues, "publicationState", $$v)
                      },
                      expression: "formValues.publicationState"
                    }
                  })
                ],
                1
              ),
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: "Versión externa",
                    "label-for": "externalVersion"
                  }
                },
                [
                  _c("b-form-input", {
                    staticClass: "w-100",
                    attrs: {
                      autocomplete: "off",
                      "data-vv-as": "Versión externa",
                      id: "externalVersion",
                      maxlength: "10",
                      name: "externalVersion",
                      "data-cy": "external-version"
                    },
                    model: {
                      value: _vm.formValues.externalVersion,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.formValues,
                          "externalVersion",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "formValues.externalVersion"
                    }
                  }),
                  _c("FormError", {
                    attrs: {
                      attributeName: "file-form.externalVersion",
                      errorsForm: _vm.errors
                    }
                  })
                ],
                1
              ),
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: "Tipo de expiración",
                    "label-for": "expirationType"
                  }
                },
                [
                  _c("b-form-select", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    staticClass: "w-100",
                    attrs: {
                      id: "expirationType",
                      name: "expirationType",
                      "data-cy": "expiration-type",
                      "data-vv-as": "Tipo de expiración",
                      options: _vm.expirationTypeOptions
                    },
                    model: {
                      value: _vm.selectedExpirationType,
                      callback: function($$v) {
                        _vm.selectedExpirationType = $$v
                      },
                      expression: "selectedExpirationType"
                    }
                  }),
                  _c("FormError", {
                    attrs: {
                      attributeName: "file-form.expirationType",
                      errorsForm: _vm.errors
                    }
                  })
                ],
                1
              ),
              _vm.selectedExpirationType ===
              _vm.expirationTypes.UNIQUE_EXPIRATION_IN_X_DAYS
                ? _c(
                    "b-form-group",
                    {
                      attrs: { label: "Días", "label-for": "expirationInXDays" }
                    },
                    [
                      _c("b-form-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value:
                              "required|numeric|min_value:1|max_value:9999",
                            expression:
                              "'required|numeric|min_value:1|max_value:9999'"
                          }
                        ],
                        attrs: {
                          "data-vv-as": "Días",
                          id: "expirationInXDays",
                          name: "expirationInXDays",
                          "data-cy": "day",
                          state:
                            !_vm.errors.has("file-form.expirationInXDays") &&
                            _vm.expirationInXDays > 0,
                          type: "number",
                          min: "1",
                          max: "9999"
                        },
                        model: {
                          value: _vm.expirationInXDays,
                          callback: function($$v) {
                            _vm.expirationInXDays =
                              typeof $$v === "string" ? $$v.trim() : $$v
                          },
                          expression: "expirationInXDays"
                        }
                      }),
                      _c("FormError", {
                        attrs: {
                          attributeName: "file-form.expirationInXDays",
                          errorsForm: _vm.errors
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.selectedExpirationType !== _vm.expirationTypes.NO_EXPIRATION
                ? _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: _vm.expirationLabel,
                        "label-for": "expirationDate"
                      }
                    },
                    [
                      _c("b-form-datepicker", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        staticClass: "form-control bg-white",
                        attrs: {
                          id: "expirationDate",
                          name: "expirationDate",
                          "data-cy": "calendar",
                          "data-vv-as": "Fecha de expiración",
                          placeholder: "Selecciona una fecha",
                          "label-help":
                            "Puede usar las flechas del teclado y espacio",
                          locale: "es",
                          min: _vm.minDate,
                          state:
                            !_vm.errors.has("file-form.expirationDate") &&
                            _vm.formValues.expirationDate !== null,
                          disabled:
                            _vm.selectedExpirationType ===
                            _vm.expirationTypes.UNIQUE_EXPIRATION_IN_X_DAYS
                        },
                        model: {
                          value: _vm.formValues.expirationDate,
                          callback: function($$v) {
                            _vm.$set(_vm.formValues, "expirationDate", $$v)
                          },
                          expression: "formValues.expirationDate"
                        }
                      }),
                      _c("FormError", {
                        attrs: {
                          attributeName: "file-form.expirationDate",
                          errorsForm: _vm.errors
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.selectedExpirationType !== _vm.expirationTypes.NO_EXPIRATION
                ? _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Hora de expiración",
                        "label-for": "expirationHour"
                      }
                    },
                    [
                      _c("b-form-select", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        staticClass: "w-100",
                        attrs: {
                          id: "expirationHour",
                          name: "expirationHour",
                          "data-cy": "hour",
                          options: _vm.hours,
                          "data-vv-as": "Hora de expiración",
                          state:
                            !_vm.errors.has("file-form.expirationHour") &&
                            _vm.formValues.expirationHour !== null
                        },
                        on: { change: _vm.setExpirationNotification },
                        model: {
                          value: _vm.formValues.expirationHour,
                          callback: function($$v) {
                            _vm.$set(_vm.formValues, "expirationHour", $$v)
                          },
                          expression: "formValues.expirationHour"
                        }
                      }),
                      _c("FormError", {
                        attrs: {
                          attributeName: "file-form.expirationHour",
                          errorsForm: _vm.errors
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.formValues.selectedExpirationType !==
                _vm.expirationTypes.NO_EXPIRATION &&
              _vm.formValues.expirationDate &&
              _vm.formValues.expirationHour
                ? _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Fecha de notificación",
                        "label-for": "notificationDate"
                      }
                    },
                    [
                      _c("b-form-datepicker", {
                        staticClass: "form-control bg-white",
                        attrs: {
                          id: "notificationDate",
                          name: "notificationDate",
                          "data-cy": "calendar",
                          placeholder: "Selecciona una fecha",
                          value: _vm.formValues.notificationDate,
                          locale: "es",
                          min: _vm.getSelectedElement.creationDate.substring(
                            0,
                            10
                          ),
                          max: _vm.formValues.expirationDate,
                          "label-help":
                            "Puede usar las flechas del teclado y espacio"
                        },
                        on: {
                          input: function(val) {
                            return _vm.setNotificationDate(val)
                          }
                        }
                      }),
                      _c("FormError", {
                        attrs: {
                          attributeName: "file-form.notificationDate",
                          errorsForm: _vm.errors
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.formValues.selectedExpirationType !==
                _vm.expirationTypes.NO_EXPIRATION &&
              _vm.formValues.expirationDate &&
              _vm.formValues.expirationHour
                ? _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Hora de notificación",
                        "label-for": "notificationHour"
                      }
                    },
                    [
                      _c("b-form-select", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "between",
                            expression: "'between'"
                          }
                        ],
                        staticClass: "w-100",
                        attrs: {
                          id: "notificationHour",
                          name: "notificationHour",
                          "data-cy": "hour",
                          options: _vm.hours,
                          "data-vv-as": "hora de notificación",
                          state: !_vm.errors.has("file-form.notificationHour")
                        },
                        model: {
                          value: _vm.formValues.notificationHour,
                          callback: function($$v) {
                            _vm.$set(_vm.formValues, "notificationHour", $$v)
                          },
                          expression: "formValues.notificationHour"
                        }
                      }),
                      _c(
                        "b-form-invalid-feedback",
                        {
                          staticClass: "d-none w-100",
                          attrs: {
                            state: !_vm.errors.has("file-form.notificationHour")
                          }
                        },
                        [
                          _vm._v(
                            " La fecha y hora debe ser antes de la expiración y posterior a la de creación "
                          )
                        ]
                      ),
                      _c("FormError", {
                        attrs: {
                          attributeName: "notificationHour",
                          errorsForm: _vm.errors
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "m-top-20 w-100 d-flex justify-end" },
            [
              _c(
                "b-button",
                {
                  staticClass: "mt-5 ml-3",
                  attrs: { variant: "outline-primary", "data-cy": "save" },
                  on: { click: _vm.save }
                },
                [
                  _vm._v(" Guardar "),
                  _c("span", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.loading,
                        expression: "loading"
                      }
                    ],
                    staticClass: "spinner-border spinner-border-sm text-white"
                  })
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }